import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/auth-context';
import { getEnvironmentVariable } from '../../utils';

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
const AUTH_URL = `${platformURL}/auth`;

const SessionTokenIframe = () => {
    const {
        isAuthenticated,
        setUserInfo,
        setSessionToken,
        setSessionTokenLoading,
    } = useAuth();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [ , setShouldAuthenticate ] = useState(false);

    useEffect(() => {
        if (!isAuthenticated) {
            window.addEventListener('message', getAuthEventListener);
            setShouldAuthenticate(true);
        }

        return () => window.removeEventListener('message', getAuthEventListener);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAuthEventListener = (event: any) => {
        if (event.data && event.data.event === 'answer') {
            setSessionTokenLoading(false);
            if (localStorage.getItem('SHOULD_NOT_AUTH')) {
                return;
            }

            const { token: sessionToken, user } = event.data.data || { token: '', user: null };
            if (!sessionToken || !user) {
                return;
            }

            setSessionToken(sessionToken);
            setUserInfo(user);
            localStorage.setItem('sessionToken', sessionToken);
            localStorage.setItem('user', JSON.stringify(user));
        }
    };

    const onIframeLoad = () => {
        setSessionTokenLoading(true);
        setTimeout(() => setSessionTokenLoading(false), 500);
        iframeRef.current?.contentWindow?.postMessage({ event: 'getAuth' }, '*');
    };

    return (
        <iframe
            style={{ display: 'none' }}
            title="-"
            ref={iframeRef}
            src={AUTH_URL}
            onLoad={onIframeLoad}
        />
    );
};

export default SessionTokenIframe;